'use client';

import type { HTMLAttributes } from 'react';
import { buttonVariants } from '@paypoteam/ui-components/Button';
import { CaretRight } from '@phosphor-icons/react/dist/ssr';
import Link from 'next/link';

import { cn } from '@/lib/utils';

export interface CtaProps extends HTMLAttributes<HTMLAnchorElement> {
    children: string;
    href: string;
    'data-test-id': string;
}

export default function Cta({ href, children, className, ...props }: CtaProps) {
    return (
        <Link
            href={href}
            className={cn(
                buttonVariants({ variant: 'ghost', className: 'w-fit' }),
                className,
            )}
            {...props}
        >
            {children}

            <CaretRight
                weight="bold"
                className="ml-1"
            />
        </Link>
    );
}
